export let filterLabels = [{
  label: '实验室技术平台',
  type: 'select',
  clearable: true,
  value: 'methodId', // 需返回数据的字段名
  options: []
}]
export const tableLabels = [
// {
//   label: '检测项目编号',
//   value: 'itemVersion',
//   minWidth: '120px'
// },
{
  label: '检测项目名称',
  value: 'itemName',
  minWidth: '120px'
},
{
  label: '检测依据',
  value: 'examBasis.name',
  minWidth: '120px'
},
{
  label: '检测周期',
  value: 'changeCycle',
  minWidth: '120px'
},
{
  label: '操作',
  slotName: 'operate',
  fixed: 'right',
  minWidth: '120px'
}
]
